<template>
  <div
    class="main-container clearfix"
    style="
      min-height: 600px;
      background: #fff;
      margin-top: 20px;
      margin-bottom: 20px;
    "
  >
    <div class="w_bfb" style="text-align: center; margin-top: 30px">
      <div class="search_box">
        <div
          class="input_item"
          @mouseover="showTypes = true"
          @mouseleave="showTypes = false"
        >
          <div class="current">
            <span v-if="type">{{ type.value }}</span>
            <img class="down" src="@/assets/images/common/arrow-down@2x.png" />
          </div>
          <div v-show="showTypes" class="types">
            <a
              class="type"
              v-for="item in types"
              :key="item.key"
              :class="{ active: item.key == type.key }"
              @click="onTypeClick(item)"
            >
              {{ item.value }}
            </a>
          </div>
        </div>
        <input
          ref="searchInput"
          class="search_input"
          type="text"
          v-model="keywords"
          :placeholder="placeholder"
          @keydown.enter="
            page = 1;
            searchSuggest();
          "
        />
        <div
          class="search_btn_img"
          @click="
            page = 1;
            searchSuggest();
          "
        ></div>
      </div>
    </div>
    <div class="search_item w_bfb" v-if="type">
      <span class="fl">搜索结果</span>
      <el-button class="fr" type="primary" @click="onInputEnter()">
        去往{{ type.value }}列表
      </el-button>
    </div>
    <div class="search_list w_bfb">
      <div class="search_suggest">
        <div
          class="search_suggest_item"
          :class="{ active: searchSuggestIndex == index }"
          v-for="(item, index) in searchSuggestItems"
          :key="item.id"
          @click="onSearchSuggestClick(item)"
        >
          <div class="cover_img"><img :src="item.cover_img" /></div>
          <div class="cont_right">
            <div class="title eps" v-html="item.title"></div>
            <div class="desc multi-line-2" v-html="item.desc"></div>
          </div>
        </div>
        <Empty
          v-if="searchSuggestItems.length == 0"
          class="empty"
          title="暂无搜到信息哦！"
        />
      </div>
      <div class="w_bfb" v-if="total > limit && searchSuggestItems.length > 0">
        <el-pagination
          background
          @current-change="handlePageChange"
          :current-page="page"
          :page-size="limit"
          layout="prev, pager, next"
          :total="total"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import { Enum } from "@/utils/enums";

export default {
  name: "SearchResult",
  data() {
    return {
      page: 1,
      limit: 9,
      total: 0,
      showSearch: true,
      keywords: this.$store.state.search,
      searchSuggestFuction: null,
      searchSuggestItems: [],
      searchSuggestIndex: -1,
      searchSuggestComplete: false,
      searchType: "",
      searchHandles: {},
      showTypes: false,
    };
  },
  computed: {
    placeholder() {
      if (this.searchType == this.searchTypes.Course) {
        return "请输入课程名称";
      } else if (this.searchType == this.searchTypes.CoursePackage) {
        return "请输入课程包名称";
      } else if (
        this.searchType == (this.searchTypes.Book || this.searchTypes.Goods)
      ) {
        return "请输入实物商品名称";
      } else if (this.searchType == this.searchTypes.Teacher) {
        return "请输入讲师名称";
      } else if (this.searchType == this.searchTypes.Periods) {
        return "请输入课时包名称";
      } else if (this.searchType == this.searchTypes.Oto) {
        return "请输入约课讲师名称";
      } else if (this.searchType == this.searchTypes.OpenCourse) {
        return "请输入公开课名称";
      } else if (this.searchType == this.searchTypes.Classes) {
        return "请输入班级名称";
      } else if (this.searchType == this.searchTypes.Ebooks) {
        return "请输入电子书名称";
      } else if (this.searchType == this.searchTypes.News) {
        return "请输入资讯名称";
      }
      return "";
    },
    searchTypes() {
      let config = this.$store.state.commonSetting;
      let types = [
        {
          id: 1,
          name: "课程",
          code: "Course",
        },
        {
          id: 7,
          name: "公开课",
          code: "OpenCourse",
        },
        // {
        //   id: 5,
        //   name: "课程包",
        //   code: "CoursePackage",
        //   hide: config.switch_package_course != 1,
        // },
        // {
        //   id: 8,
        //   name: "班级",
        //   code: "Classes",
        //   hide: config.switch_class_module != 1,
        // },
        // {
        //   id: 4,
        //   name: "实物商品",
        //   code: "Goods",
        //   hide: config.switch_goods_module != 1,
        // },
        // {
        //   id: 9,
        //   name: "电子书",
        //   code: "Ebooks",
        //   hide: config.switch_ebook_module != 1,
        // },
        {
          id: 3,
          name: "讲师",
          code: "Teacher",
        },
        // {
        //   id: 6,
        //   name: "课时包",
        //   code: "Periods",
        //   hide: config.switch_contract_schedule != 1,
        // },
        // {
        //   id: 2,
        //   name: "一对一约课",
        //   code: "Oto",
        //   hide: config.switch_oto_module != 1,
        // },
        {
          id: 10,
          name: "资讯",
          code: "News",
        },
      ];
      let searchTypes = new Enum(types.filter(t => t.hide != true));
      return searchTypes;
    },
    types() {
      return this.searchTypes.getOptions();
    },
    type() {
      return this.types.find(t => t.key == this.searchType);
    },
  },
  watch: {
    show(newValue) {
      this.showSearch = newValue;
      if (!newValue) {
        this.keywords = "";
        this.searchSuggestItems = [];
      }
    },
    showSearch(newValue) {
      this.$emit("update:show", newValue);
    },
    searchTypes() {
      this.init();
    },
  },
  created() {
    this.init();
    this.searchHandles = {
      [this.searchTypes.Course]: {
        search: () => {
          this.$router.push({
            name: "Course",
            query: { keywords: this.keywords },
          });
        },
        searchSuggestClick: item => {
          if (item.course_type == 3) {
            this.$router.push({
              name: "CourseShow",
              params: { id: item.id },
              query: { recommend: 3, title: "公开课" },
            });
          } else {
            this.$router.push({ name: "CourseShow", params: { id: item.id } });
          }
        },
      },
      [this.searchTypes.OpenCourse]: {
        search: () => {
          this.$router.push({
            name: "OpenCourse",
            query: { keywords: this.keywords, course_type: 3, nav: 25 },
          });
        },
        searchSuggestClick: item => {
          if (item.course_type == 3) {
            this.$router.push({
              name: "CourseShow",
              params: { id: item.id },
              query: { recommend: 3, title: "公开课" },
            });
          } else {
            this.$router.push({
              name: "CourseShow",
              params: { id: item.id },
            });
          }
        },
      },
      [this.searchTypes.Goods]: {
        search: () => {
          this.$router.push({
            name: "Goods",
            query: { keywords: this.keywords },
          });
        },
        searchSuggestClick: item => {
          this.$router.push({ name: "GoodsDetail", params: { id: item.id } });
        },
      },
      [this.searchTypes.Ebooks]: {
        search: () => {
          this.$router.push({
            name: "Ebooks",
            query: { keywords: this.keywords },
          });
        },
        searchSuggestClick: item => {
          this.$router.push({ name: "EbooksDetail", params: { id: item.id } });
        },
      },
      [this.searchTypes.Teacher]: {
        search: () => {
          this.$router.push({
            name: "ShowTeachers",
            query: { keywords: this.keywords },
          });
        },
        searchSuggestClick: item => {
          this.$router.push({
            name: "ShowTeachersDetaial",
            params: { id: item.id },
          });
        },
      },
      [this.searchTypes.CoursePackage]: {
        search: () => {
          this.$router.push({
            name: "Package",
            query: { keywords: this.keywords },
          });
        },
        searchSuggestClick: item => {
          this.$router.push({
            name: "PackageDetail",
            params: { id: item.id },
          });
        },
      },
      [this.searchTypes.Periods]: {
        search: () => {
          this.$router.push({
            name: "Periods",
            query: { keywords: this.keywords },
          });
        },
        searchSuggestClick: item => {
          this.$router.push({
            name: "PeriodsDetail",
            params: { id: item.id },
          });
        },
      },
      [this.searchTypes.Oto]: {
        search: () => {
          this.$router.push({
            name: "Oto",
            query: { keywords: this.keywords },
          });
        },
        searchSuggestClick: item => {
          this.$router.push({
            name: "OtoTeacherShow",
            params: { id: item.id },
          });
        },
      },
      [this.searchTypes.Classes]: {
        search: () => {
          this.$router.push({
            name: "Classes",
            query: { keywords: this.keywords },
          });
        },
        searchSuggestClick: item => {
          this.$router.push({ name: "ClassesDetail", params: { id: item.id } });
        },
      },
      [this.searchTypes.News]: {
        search: () => {
          this.$router.push({
            name: "News",
            query: { keywords: this.keywords },
          });
        },
        searchSuggestClick: item => {
          this.$router.push({ name: "NewsShow", params: { id: item.id } });
        },
      },
    };
  },
  async mounted() {
    await this.$nextTick();
    this.$refs.searchInput.focus();
    document.addEventListener("click", () => {
      this.showSearch = false;
    });
  },
  methods: {
    async handlePageChange(page) {
      this.page = page;
      await this.searchSuggest();
    },
    init() {
      this.searchType = this.searchTypes.Course;
    },
    async onTypeClick(type) {
      this.searchType = type.key;
      this.showTypes = false;
      this.page = 1;
      await this.searchSuggest();
    },
    search() {
      this.showSearch = false;
      let handle = this.searchHandles[this.searchType];
      if (handle) {
        handle.search();
      }
    },
    removeHTMLTag(str) {
      if (str) {
        str = str.replace(/<\/?[^>]*>/g, ""); //去除HTML tag
        str = str.replace(/[ | ]*\n/g, "\n"); //去除行尾空白
        str = str.replace(/\n[\s| | ]*\r/g, "\n"); //去除多余空行
        str = str.replace(/&nbsp;/gi, ""); //去掉&nbsp;
      }
      return str;
    },
    async searchSuggest() {
      this.searchSuggestComplete = false;
      if (!this.keywords) {
        this.searchSuggestItems = [];
        return;
      }
      if (!this.searchSuggestFuction) {
        this.searchSuggestFuction = this.$pub.debounce(async () => {
          if (!this.keywords) {
            this.searchSuggestItems = [];
            return;
          }
          let data = await this.$http.get("/api/app/keywordsPaginator", {
            type: this.searchType,
            page: this.page,
            limit: this.limit,
            course_type:
              this.searchType == 7 ? 3 : this.searchType == 1 ? 1 : "",
            keywords: encodeURIComponent(this.keywords),
          });
          let list = data.data;
          this.total = data.total;
          list.forEach(item => {
            item.desc = this.removeHTMLTag(item.details);
            item.title = item.name ? item.name : item.title;
            item.title = item.title.replace(
              new RegExp(this.keywords, "g"),
              '<span class="primary-color">' + this.keywords + "</span>",
            );
          });
          this.searchSuggestItems = list;
          this.searchSuggestIndex = -1;
          this.searchSuggestComplete = true;
        }, 200);
      }
      this.searchSuggestFuction();
    },
    searchSuggestUp() {
      if (this.searchSuggestIndex == -1) {
        return;
      }
      this.searchSuggestIndex--;
    },
    searchSuggestDown() {
      if (this.searchSuggestIndex == this.searchSuggestItems.length - 1) {
        return;
      }
      this.searchSuggestIndex++;
    },
    onSearchSuggestClick(item) {
      item = item || this.searchSuggestItems[this.searchSuggestIndex];
      if (!item) {
        return;
      }
      let handle = this.searchHandles[this.searchType];
      if (handle) {
        handle.searchSuggestClick(item);
      }
      this.showSearch = false;
      this.searchSuggestIndex = -1;
    },
    onInputEnter() {
      if (this.searchSuggestIndex >= 0) {
        this.onSearchSuggestClick();
      } else {
        this.search();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.search_box {
  text-align: center;
  display: inline-block;
  vertical-align: top;
  width: 644px;
  line-height: 46px;
  position: relative;
  z-index: 9;
  left: 50%;
  top: 16px;
  height: 48px;
  transform: translateX(-50%);
  background: white;
  display: flex;
  align-items: center;
  border: 1px solid #dbdbdb;
  border-radius: 20px;
  box-sizing: border-box;
  .search_input {
    float: left;
    flex-grow: 1;
    background: none;
    height: 42px;
    line-height: 42px;
    border: none;
    outline: none;
    padding-right: 80px;
    color: #333333;
    box-sizing: border-box;
    caret-color: #ccc;
    &::placeholder {
      color: #ccc;
    }
  }
  .search_btn_img {
    width: 24px;
    height: 24px;
    display: block;
    position: absolute;
    top: 12px;
    right: 10px;
    cursor: pointer;
    background: url(~@/assets/images/common/Frame3017@2x.png) no-repeat;
    background-size: 24px 24px;
  }
  .input_item {
    float: left;
    position: relative;
    height: 48px;
    line-height: 48px;
    left: 0px;
    margin-left: 20px;
    .current {
      cursor: pointer;
      float: left;
    }

    .down {
      width: 12px;
      height: 7px;
      margin: 0 10px 0 12px;
    }
    .types {
      width: 160px;
      opacity: 1;
      background: #ffffff;
      box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.1);
      position: absolute;
      left: -20px;
      top: 48px;
      .type {
        cursor: pointer;
        display: block;
        color: #333;
        text-align: left;
        height: 36px;
        line-height: 36px;
        padding-left: 12px;

        &:hover {
          background: rgba($color: $primary-color, $alpha: 0.08);
        }
        &:active {
          color: $primary-color;
        }
      }
      .active {
        background: rgba($color: $primary-color, $alpha: 0.08);
        color: $primary-color;
      }
    }
  }
}
.search_item {
  margin-top: 50px;
  padding: 0px 35px;
  box-sizing: border-box;
  .fl {
    float: left;
    font-size: 18px;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: 700;
    line-height: 40px;
  }
  .fr {
    float: right;
  }
}
.search_suggest {
  width: 100%;
  float: left;
  padding: 20px;
  box-sizing: border-box;
  .search_suggest_item {
    width: 100%;
    float: left;
    cursor: pointer;
    box-sizing: border-box;
    border-bottom: 1px dashed #ededed;
    padding: 0px 15px;
    padding-bottom: 15px;
    border-radius: 4px;
    .cover_img {
      width: 180px;
      float: left;
      height: 120px;
      border-radius: 4px;
      overflow: hidden;
      margin-top: 15px;
      img {
        width: 100%;
        min-height: 120px;
        transition: all 0.3s;
      }
    }
    .cont_right {
      width: calc(100% - 210px);
      float: left;
      margin-left: 15px;
      margin-top: 10px;
      .title {
        width: 100%;
        float: left;
        height: 30px;
        font-size: 18px;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 700;
        text-align: left;
        color: #666;
        line-height: 30px;
        margin-top: 15px;
      }
      .desc {
        width: 100%;
        float: left;
        font-size: 14px;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        text-align: left;
        color: #666;
        line-height: 24px;
        margin-top: 10px;
      }
    }
    &:hover,
    &.active {
      img {
        transform: scale(1.1);
      }
      background: rgba(237, 237, 237, 0.2);
    }
  }
}
</style>
